import React, { useEffect, useState } from 'react';
import { getDeviceStatusCode } from 'utils/iconUtils';
import styles from './NodeStatus.module.css';

export default function NodeStatus({ device }) {
  const [status, setStatus] = useState();

  useEffect(() => setStatus(getDeviceStatusCode(device)), [device]);

  if (!status) return null;

  return (
    <div className={styles.root} status={status || 'Offline'}>
      {device?.data ? status : 'Offline'}
    </div>
  );
}
